import apiService from './apiService.js';
import PaginatedRepository from './PaginatedRepository';

export default {
    getPaginatedBibleStudyPlans(pageSize, currentPage) {
        return PaginatedRepository.getPaginated('/bible_study_plans/my_bible_study_plans', pageSize, currentPage);
    },
    getBibleStudyPlanById(id) {
        return new Promise((resolve, reject) => {
            apiService.get(`bible_study_plans/${id}`)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => reject(error));
        });
    },
    updateBibleStudyPlan(bibleStudyPlan) {
        return new Promise((resolve, reject) => {
            apiService.put(`bible_study_plans/${bibleStudyPlan.id}`, bibleStudyPlan)
                .then((response) => resolve(response))
                .catch(((error) => reject(error)));
        });
    },
    addNewBibleStudyPlan(title, materialId) {
        return apiService.post(
            '/bible_study_plans',
            {
                title,
                material_id: materialId
            }
        );
    },

    deleteBibleStudyPlan(id) {
        return apiService.delete(`/bible_study_plans/${id}`);
    }
};
